import { axios_ } from "@/tools/axios_";
// 手机号校验
export const validatePhone = () => ({
  pattern: /^1[3456789]\d{9}$/,
  validateTrigger: 'onBlur',
  message: '手机号码格式不正确',
});

export const validatePhoneRequired = () => ({
  required: true,
  validateTrigger: 'onBlur',
  message: '请输入手机号',
})

const passwordType = {
  0: '请输入旧密码',
  1: '请输入新密码',
  2: '请再次输入新密码'
}

// 密码必填
export const validPasswordRequired = (type = 0) => ({
  required: true,
  validateTrigger: 'onBlur',
  message: passwordType[type],
});

// 密码校验
export const validPassword = () => ({
  pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
  max: 20,
  min: 6,
  message: '密码格式不正确（8-20位，至少包括大写字符、小写字符、数字、特殊字符其中3类或以上）',
});

export const newPasswordCheck = () => ({
  pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
  max: 20,
  min: 6,
  message: '新密码格式不正确（8-20位，至少包括大写字符、小写字符、数字、特殊字符其中3类或以上）',
});

export const checkExistPhone = async (rule, value) => {
  return Promise.resolve();
  if (value.length === 11) {
    return axios_({
      url: '/api/organization/orgCompany/info/get',
      method: 'get',
      params: {
        mobile: value
      }
    }).then(res => {
      if (res.data.status === 200) {
        if (res.data.data.length == 0) {
          return Promise.reject('手机号未注册，请联系公司管理员')
        }
      }
    })
      .finally(() => {
        return Promise.resolve()
      });
  }
}
